import $ from 'jquery';

global.$ = global.jQuery = $;

import instantsearch from 'instantsearch.js';
import 'ion-rangeslider';
import ionRangeSlider from './instantsearch-ion.rangeSlider';

instantsearch.widgets.ionRangeSlider = ionRangeSlider;

var lastISLaunching = null;
var infiniteScrollingEnabled = true;
var paddingIS = 100;
var minSecondLaunchIS = 0.2;

//<![CDATA[
'use strict';
;(function(window, document, ud){
    /**
     * @param options
     * @constructor
     */
    initBOXA('CATALOG');
    window.VehicleSearch = function(options) {

        var plugin = this;

        // options par défaut.
        plugin.options = {
            currentFilters: [],
            initialSearchParameters: [],
            searchParameters: function(initialSearchParameters) { return initialSearchParameters;},
            searchFunction: function(helper) {},
            launchOnLoad: true,
            baseSearchUrl: '/recherche',
            enableInfiniteScrolling: true
        };

        plugin.instantsearchInstance;

        plugin.getOptions = function () {
            return plugin.options;
        };

        plugin.getInstantsearchInstance = function () {
            return plugin.instantsearchInstance;
        };

        plugin.start = function() {
            initWidgets();
            plugin.instantsearchInstance.start();
        };

        var init = function(options) {
            plugin.options = $.extend({}, plugin.options, options || {});
            initInstantsearch();

            return plugin;
        };

        var initInstantsearch = function() {
            plugin.instantsearchInstance = instantsearch({
                appId: options.appId,
                apiKey: options.apiKey,
                indexName: options.indexName,
                searchParameters: plugin.options.searchParameters(getInitialSearchParameters(plugin.options.initialSearchParameters)),
                urlSync: {
                    trackedParameters: ['attribute:*', 'query', 'index']
                },
                searchFunction: function (helper) {
                    var _queryId = helper._queryId;

                    $('[search-infinite-hits]').show();//Show algolia result search
                    $('.ais-infinite-hits').addClass('cs-show');
                    $('[search-results-server]').hide();//Hide server result search
                    $('[search-stats]').show();//Show Algolia stats

                    infiniteScrollingEnabled = true;

                    if( _queryId == 0 &&//First search
                        plugin.options.launchOnLoad == false) {

                        $('[search-infinite-hits]').hide();//Hide algolia result search
                        $('.ais-infinite-hits').remove('cs-show');
                        $('[search-results-server]').show();//Show server result search
                        $('[search-stats]').hide();//Hide Algolia stats

                        infiniteScrollingEnabled = false;
                    }

                    plugin.options.searchFunction(helper);

                    helper.search();

                    if( _queryId != 0) {
                        var searchUrl = window.location.origin + plugin.options.baseSearchUrl;
                        var currentUrl = window.location.origin + window.location.pathname;

                        if( searchUrl != currentUrl) {
                            var newUrl = searchUrl + window.location.search;
                            window.history.pushState({}, '', newUrl);
                        }
                    }

                  window.setTimeout(function() {
                    // initBOXA('CATALOG');
                    reloadVehicleData();
                  }, 1000);

                  window.setInterval(function() {
                    // initBOXA('CATALOG');
                    reloadVehicleData();
                  }, 6000);

                }
            });
        }

        var initWidgets = function() {
            if( $("[search-stats]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.stats({
                        container: $("[search-stats]")[0],
                        templates: {
                            body: ' {{#query}} Résulat pour la recherche "{{ query }}" :{{/query}} {{#hasNoResults}} Aucun résultat{{/hasNoResults}} {{#hasOneResult}} 1 voiture{{/hasOneResult}} {{#hasManyResults}} {{nbHits}} voitures{{/hasManyResults}}'
                        }
                    })
                );
            }

            if( $("[search-filter-search-box]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.searchBox({
                        container: $("[search-filter-search-box]")[0],
                        placeholder: 'Rechercher',
                        autofocus: false,
                        poweredBy: false
                    })
                );
            }

            if( $("[search-filter-list-cond]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-cond]")[0],
                        attributeName: 'cond',
                        operator: 'or',
                        collapsible: false,
                        transformData: {
                            item: function (item) {
                                item.name = (item.name == 'vo' ? 'Occasions' : 'Neuves');
                                return item;
                            }
                        },
                        templates: {
                            item: '<div class="btn-cond btn-cond--{{ name }}"><span>{{ name }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'cond',
                        transformData: function(item) {
                            item.name = (item.name == 'vo' ? 'Occasions' : 'Neuves');

                            return item;
                        },
                        template: '<div>{{name}}&nbsp;<i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-slider-price]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    ionRangeSlider({
                        container: $("[search-filter-slider-price]")[0],
                        attributeName: 'pricing.price',
                        ionRangeSliderOptions: {
                            type: 'double',
                            grid: false,
                            postfix: '&nbsp;€',
                            step: 1000,
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'pricing.price',
                        transformData: function(item) {
                            item.superior = (item.operator == '>=');
                            return item;
                        },
                        template: '<div>{{#superior}}Plus de{{/superior}}{{^superior}}Moins de{{/superior}}&nbsp;{{name}}&nbsp;€ <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-slider-monthly-payment]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    ionRangeSlider({
                        container: $("[search-filter-slider-monthly-payment]")[0],
                        attributeName: 'funding.monthlyPayment',
                        ionRangeSliderOptions: {
                            type: 'double',
                            grid: false,
                            postfix: '€/mois',
                            step: 50,
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'funding.monthlyPayment',
                        transformData: function(item) {
                            item.superior = (item.operator == '>=');
                            return item;
                        },
                        template: '<div>{{#superior}}Plus de{{/superior}}{{^superior}}Moins de{{/superior}}&nbsp;{{name}}€/mois <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-maker]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-maker]")[0],
                        attributeName: 'maker.name',
                        operator: 'or',
                        limit: 30,
                        collapsible: true,
                        templates: {
                            header: 'Marques',
                            item: '<div class="motor-btn-filter">{{ name }} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'maker.name',
                        template: '<div>{{name}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-model]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-model]")[0],
                        attributeName: 'model.name',
                        operator: 'or',
                        limit: 100,
                        collapsible: {
                            collapsed: true,
                        },
                        templates: {
                            header: 'Modèles',
                            item: '<div class="motor-btn-filter">{{ name }}<span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'model.name',
                        template: '<div>{{name}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-energy]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-energy]")[0],
                        attributeName: 'energy',
                        operator: 'or',
                        limit: 10,
                        collapsible: true,
                        templates: {
                            header: 'Énergies',
                            item: '<div class="motor-btn-filter">{{ name }} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'energy',
                        template: '<div>{{name}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-tags]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-tags]")[0],
                        attributeName: 'vehicleTags.name',
                        operator: 'or',
                        limit: 10,
                        collapsible: true,
                        templates: {
                            header: 'Nos sélections',
                            item: '<div class="motor-btn-filter">{{ name }} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'vehicleTags.name',
                        template: '<div>{{name}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-seats]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-seats]")[0],
                        attributeName: 'seats',
                        operator: 'or',
                        limit: 10,
                        collapsible: true,
                        templates: {
                            header: 'Nombre de places',
                            item: '<div class="motor-btn-filter">{{ name }} places<span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'seats',
                        template: '<div>{{name}} places<i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-category]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-category]")[0],
                        attributeName: 'categoryName',
                        operator: 'or',
                        limit: 10,
                        collapsible: true,
                        transformData: {
                            item: function(item) {
                                item.nameLowerCase = item.name.toLowerCase();
                                if (typeof item.nameLowerCase.normalize === "function") {
                                    item.nameLowerCase = item.nameLowerCase.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                                }
                                item.nameLowerCase = item.nameLowerCase.replace(/\s/g, "-");
                                return item;
                            }
                        },
                        templates: {
                            header: 'Types de véhicules',
                            item: '<div class="btn motor-btn-filter motor-btn-filter--category cat-{{ nameLowerCase }}">{{ name }} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'categoryName',
                        template: '<div>{{name}}'
                    }
                );
            }

            if( $("[search-filter-list-normalized-equipment]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-normalized-equipment]")[0],
                        attributeName: 'normalizedEquipment',
                        operator: 'and',
                        limit: 10,
                        collapsible: true,
                        transformData: {
                            item: function (item) {
                                item.nameLowerCase = item.name
                                    .toLowerCase()
                                    .replace(/\s+/g, '-')           // Replace spaces with -
                                    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                                    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                                    .replace(/^-+/, '')             // Trim - from start of text
                                    .replace(/-+$/, '')
                                ;

                                return item;
                            }
                        },
                        templates: {
                            header: 'Equipement',
                            item: '<div class="btn motor-btn-filter motor-btn-filter--equipment equip-{{nameLowerCase}}">{{ name }}</div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'normalizedEquipment',
                        template: '<div>{{name}}'
                    }
                );
            }

            if( $("[search-filter-slider-mileage]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    ionRangeSlider({
                        container: $("[search-filter-slider-mileage]")[0],
                        attributeName: 'mileage',
                        ionRangeSliderOptions: {
                            type: 'double',
                            grid: false,
                            postfix:'&nbsp;km',
                            step: 10000,
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'mileage',
                        transformData: function(item) {
                            item.superior = (item.operator == '>=');
                            return item;
                        },
                        template: '<div>{{#superior}}Plus de{{/superior}}{{^superior}}Moins de{{/superior}}&nbsp;{{name}}&nbsp;km <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-gearbox-auto]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-gearbox-auto]")[0],
                        collapsible: true,
                        attributeName: 'gearboxAuto',
                        operator: 'or',
                        limit: 10,
                        transformData: {
                            item: function(item) {
                                item.gearboxAuto = (item.name == 'true');
                                return item;
                            }
                        },
                        templates: {
                            header: 'Boîte de vitesse',
                            item: '<div class="motor-btn-filter">{{#gearboxAuto}}Automatique{{/gearboxAuto}}{{^gearboxAuto}}Manuelle{{/gearboxAuto}} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'gearboxAuto',
                        transformData: function(item) {
                            item.gearboxAuto = (item.name == 'true');
                            return item;
                        },
                        template: '<div>Boîte {{#gearboxAuto}}Automatique{{/gearboxAuto}}{{^gearboxAuto}}Manuelle{{/gearboxAuto}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-list-year]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.refinementList({
                        container: $("[search-filter-list-year]")[0],
                        attributeName: 'year',
                        operator: 'or',
                        limit: 10,
                        collapsible: true,
                        sortBy: ['name:desc'],
                        templates: {
                            header: 'Année',
                            item: '<div class="motor-btn-filter">{{ name }} <span class="motor-count">{{ count }}</span></div>'
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'year',
                        template: '<div>{{name}} <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-slider-year]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    ionRangeSlider({
                        container: $("[search-filter-slider-year]")[0],
                        attributeName: 'year',
                        ionRangeSliderOptions: {
                            type: 'double',
                            grid: false,
                            step: 1,
                        }
                    })
                );

                plugin.options.currentFilters.push(
                    {
                        name: 'year',
                        transformData: function(item) {
                            item.superior = (item.operator == '>=');
                            return item;
                        },
                        template: '<div>{{#superior}}Plus de{{/superior}}{{^superior}}Moins de{{/superior}}&nbsp;{{name}}&nbsp; <i class="icon-croix"></i></div>'
                    }
                );
            }

            if( $("[search-filter-current]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.currentRefinedValues({
                        container: $("[search-filter-current]")[0],
                        clearAll: false,
                        templates: {
                            item: '<div>{{ name }} <i class="icon-croix"></i></div>'
                        },
                        attributes: plugin.options.currentFilters,
                        onlyListedAttributes: true
                    })
                );
            }

            if( $("[search-filter-clear-all]").length != 0) {
                plugin.instantsearchInstance.addWidget({
                    init: function(args) {
                        var helper = args.helper;
                        $("[search-filter-clear-all]").click(function() {
                            helper.setQuery('').clearRefinements().search();
                        });
                    },
                    render:function(args) {
                        var helper = args.helper;
                        var state = helper.getState();
                        //Check refined facets and query. If we dont't have any, hide widget.
                        if(state.getRefinedDisjunctiveFacets()=='' && state.getQueryParameter('query')==''){
                            $("[search-filter-clear-all]").hide();
                            return false;
                        }
                        $("[search-filter-clear-all]")
                            .html('<div class="ais-current-refined-values--item"><div class="ais-current-refined-values--link">Tout effacer</div></div>')
                            .show();
                    }
                });
            }

            if( $("[search-filter-sort-by]").length != 0) {
                if( plugin.options.sortIndices == undefined) {
                    throw "You must defined 'sortIndices' option in VehicleSearch";
                }

                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.sortBySelector({
                        container: $("[search-filter-sort-by]")[0],
                        indices: plugin.options.sortIndices
                    })
                );
            }

            if( $("[search-infinite-hits]").length != 0) {
                plugin.instantsearchInstance.addWidget(
                    instantsearch.widgets.infiniteHits(
                        $.extend(
                            {
                                container: $("[search-infinite-hits]")[0],
                                templates: {
                                    empty: $("[search-no-result]").html(),
                                    item: $("[search-hits]").html()
                                },
                                transformData: plugin.options.hitsItemTransformData,
                                hitsPerPage: 20
                            },
                            plugin.options.infiniteHits
                        )
                    )
                );

                window.onscroll = function (ev) {
                    var paddingBeforeEndList = ($("[search-infinite-hits]").parent().offset().top +  + $("[search-infinite-hits]").parent().height()) - ($(window).scrollTop() + $(window).innerHeight());

                    if (
                        paddingBeforeEndList < paddingIS &&
                        (
                            lastISLaunching == undefined ||
                            (( new Date() - lastISLaunching) / 1000) > minSecondLaunchIS
                        ) &&
                        infiniteScrollingEnabled == true &&
                        plugin.options.enableInfiniteScrolling
                    ) {
                        lastISLaunching = new Date();

                        $('.ais-infinite-hits--showmore button').click();
                        console.log('scrollUpdate ?');
                      window.setTimeout(function() {
                        initBOXA('CATALOG');
                        reloadVehicleData();
                      }, 1000)
                    }
                };
            }
        }

        var getInitialSearchParameters = function(params) {

            var disjunctiveFacets = [];
            var disjunctiveFacetsRefinements = {};
            var facetsRefinements = {};
            var facets = [];

            //Filter on agency stock
            if (params.agencyId != undefined && params.agencyId != '') {
                facetsRefinements["mainAgency"] = [params.agencyId];
                facets.push('mainAgency');
            }

            //Filter on cond field
            if (params.cond != undefined && params.cond != '') {
                disjunctiveFacets.push('cond');
                disjunctiveFacetsRefinements['cond'] = [params.cond];
            }

            //Filter on maker field
            if (params.makerName != undefined && params.makerName != '') {
                disjunctiveFacets.push('maker.name');
                disjunctiveFacetsRefinements['maker.name'] = [params.makerName];
            }

            //Filter on model field
            if (params.modelName != undefined && params.modelName != '') {
                disjunctiveFacets.push('model.name');
                disjunctiveFacetsRefinements['model.name'] = [params.modelName];
            }

            //Filter on tag field
            if (params.vehicleTagName != undefined && params.vehicleTagName != '') {
                facetsRefinements["vehicleTags.name"] = [params.vehicleTagName];
                facets.push('vehicleTags.name');
            }

            var searchParameters = {};

            const isLaura = window.location.host.includes('autolaura');

            if(!isLaura) {
                if( disjunctiveFacets.length != 0 || disjunctiveFacetsRefinements.length != 0 || facets.length != 0 || facetsRefinements.length != 0) {
                    searchParameters = {
                        disjunctiveFacets: disjunctiveFacets,
                        disjunctiveFacetsRefinements: disjunctiveFacetsRefinements,
                        facets: facets,
                        facetsRefinements: facetsRefinements,
                        filters: 'mainAgency.id != 55'
                    };
                }
            } else {
                if( disjunctiveFacets.length != 0 || disjunctiveFacetsRefinements.length != 0 || facets.length != 0 || facetsRefinements.length != 0) {
                    searchParameters = {
                        disjunctiveFacets: disjunctiveFacets,
                        disjunctiveFacetsRefinements: disjunctiveFacetsRefinements,
                        facets: facets,
                        facetsRefinements: facetsRefinements
                    };
                }
            }


            return searchParameters;
        };

        init(options);
    };

})(window, document);
//]]>



// WEBPACK FOOTER //
// ./app/Resources/assets/algolia/search.js